import { LabClient, QueriesClient } from "@app/api2/api";
import { useEffect, useState } from "react";
import { SelectableItem, SelectableItemTyped, useSelectableList } from "./UseSelectableList";
import { useUser } from "../Contexts/UserContext";
import { FormDropdown } from "@/components/bp/bp-ui";
import React from "react";



interface UseSelectableListOptions {
  defaultId?: any;
  deps?: any[];
}

export function useLabs({
  defaultId,
  deps = [],
}: UseSelectableListOptions) {
  const labClient = new QueriesClient();
  const user = useUser();

  const labs = useSelectableList<SelectableItemTyped<number>, number>({
    apiCall: () => {
      return labClient.getAllLabs().then(response => response.labs.map(lab => ({ id: lab.id, value: lab.id, text: lab.name })));
    },
    defaultId: defaultId ?? user?.user?.lab?.id,
    deps: [user, defaultId, ...deps],
    selectFirst: true
  });

return {...labs, renderCombo: () => {
  return (
    <FormDropdown
      label={window.translation.common.lab}
      fluid
      selection
      required
      options={labs.items}
      value={labs.selectedId}
      onChange={(_, data) => labs.setSelectedId(data.value as number)}
    />
  );
}};
}